var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-markdown',_vm._b({attrs:{"find-user":_vm.findUser},on:{"click-anchor":_vm.clickAnchor,"click-mention":_vm.clickMention,"mark":_vm.mark}},'base-markdown',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }